import * as CONST from "./actionTypes";

export const getDrivers = (payload, params, callBack) => {
  return {
    type: CONST.GET_DRIVERS,
    payload,
    params,
    callBack,
  };
};

export const getDriversSuccess = (payload, callBack) => {
  return {
    type: CONST.GET_DRIVERS_SUCCESS,
    payload,
    callBack,
  };
};

export const getDriversFail = (payload, callBack) => {
  return {
    type: CONST.GET_DRIVERS_FAIL,
    payload,
    callBack,
  };
};

export const updateDriversList = (payload, callBack) => {
  return {
    type: CONST.UPDATE_DRIVERS_LIST,
    payload,
    callBack,
  };
};

// by id

export const getDriverView = (payload, callBack) => {
  return {
    type: CONST.GET_DRIVER_VIEW,
    payload,
    callBack,
  };
};

export const getDriverViewSuccess = (payload, callBack) => {
  return {
    type: CONST.GET_DRIVER_VIEW_SUCCESS,
    payload,
    callBack,
  };
};

export const getDriverViewFail = (payload, callBack) => {
  return {
    type: CONST.GET_DRIVER_VIEW_FAIL,
    payload,
    callBack,
  };
};
